import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-logo,[app-logo]',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './logo.component.html',
})
export class LogoComponent {}
